"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseValue = exports.parseQuantityPickerValueToNumber = exports.parseQuantityPickerValue = exports.getPrice = exports.getPoints = exports.getButtons = void 0;
var _icons = require("@ori-ui/icons");
const parseValue = (param)=>{
    let { maxQuantityToBuy, value } = param;
    return Math.max(Math.min(value, maxQuantityToBuy), 0);
};
exports.parseValue = parseValue;
const parseQuantityPickerValueToNumber = (param)=>{
    let { maxQuantityToBuy, value } = param;
    return typeof value === 'number' ? parseValue({
        maxQuantityToBuy,
        value
    }) : 0;
};
exports.parseQuantityPickerValueToNumber = parseQuantityPickerValueToNumber;
const parseQuantityPickerValue = (param)=>{
    let { maxQuantityToBuy, value } = param;
    return typeof value === 'number' ? parseValue({
        maxQuantityToBuy,
        value
    }) : value;
};
exports.parseQuantityPickerValue = parseQuantityPickerValue;
const getButtons = (param)=>{
    let { maxQuantityToBuy, productBoxButtons, quantity } = param;
    return {
        ...productBoxButtons,
        quickBuy: {
            trigger: true,
            disabled: maxQuantityToBuy <= quantity,
            // quickbuy button is always visible. Delete this, when addToBasketVisible will be fixed for all products
            visible: true
        }
    };
};
exports.getButtons = getButtons;
const getPoints = (param)=>{
    let { isCampaignOffer, isHeartFormat, rawPoints } = param;
    return rawPoints > 0 ? {
        productPoints: rawPoints,
        currency: isCampaignOffer && isHeartFormat ? _icons.RewardsHeartsFilled : undefined
    } : null;
};
exports.getPoints = getPoints;
const getPrice = (param)=>{
    let { formatPrice, productBoxPrice, rawOriginalPrice, rawPrice } = param;
    return {
        currentFormatted: formatPrice(rawPrice),
        old: rawOriginalPrice !== undefined && rawOriginalPrice > rawPrice ? formatPrice(rawOriginalPrice) : productBoxPrice === null || productBoxPrice === void 0 ? void 0 : productBoxPrice.old
    };
};
exports.getPrice = getPrice;
